const defaultState = {
  showEditWeighInModal: false,
  showEditNoteModal: false,
  showAddNoteModal: false,
  selectedWeighInIndex: 0,
  selectedNoteIndex: 0,
  selectedUserIndex: 0,
}

const user = (state=defaultState, action) => {
  switch(action.type) {
    case 'SHOW_EDIT_WEIGHIN_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_EDIT_NOTE_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_ADD_NOTE_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'RESET_REDUX_STATE':
      state = defaultState;
      break;
    default: // Do nothing
  }
  return state;
};

export default user
